class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

// 外部リンク別タブ表示
document.addEventListener("DOMContentLoaded", function() {
  const anchorTags = document.querySelectorAll("a");

  // 対象となるキーワードのリスト
  const keywords = ["採用に関する問い合わせ", "WELL SLEEP CLINIC", "スリーププランナー", "コンディショニングスタジオ"];
  anchorTags.forEach(function(anchor) {
    keywords.forEach(function(keyword) {
      if (anchor.textContent.includes(keyword)) {
        anchor.setAttribute("target", "_blank");
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function() {
  // ページ内に .header__active-menu-item が存在するか確認
  var activeMenuItem = document.querySelector(".header__active-menu-item");

  // 存在する場合、親要素の a タグまたは summary タグに .no-hover クラスを追加
  if (activeMenuItem) {
    // まず a タグを探す
    var parentAnchor = activeMenuItem.closest("a");
    if (parentAnchor) {
      parentAnchor.classList.add("no-hover");
    } else {
      // a タグがない場合、summary タグを探す
      var parentSummary = activeMenuItem.closest("summary");
      if (parentSummary) {
        parentSummary.classList.add("no-hover");
      }
    }
  }
});